module.exports = __webpack_public_path__ + "img/order_btn_delete_normal-01.f6e33248.svg";